import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { DocumentoService } from '../../services/documento.service';
import { AppTitleService } from '../../services/app-title.service';
import { DateService, MY_DATE_FORMATS } from '../../shared/date.service';
import { Documento } from '../../models/Document';
import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AsyncPipe, Location } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { UnidadOrganizacional } from '../../models/UnidadOrganizacional';
import { ServidorPublico } from '../../models/ServidorPublico';
import { ScnackbarData, ToastService, SnackbarStyles } from '../../commons/toast.service';
import { AuthService } from '../../services/auth.service';
import { AccionTarea } from '../../models/Tarea';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { UltimoUsoPipe } from '../../pipes/ultimo-uso.pipe';
import { ComentarService } from '../../services/comentar.service';
import { TableSelectedDocumentsComponent } from "../../commons/table-selected-documents/table-selected-documents.component";

@Component({
    selector: 'app-comentar',
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'es-EC' },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    ],
    imports: [
        MatTableModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        MatIconModule,
        MatProgressSpinnerModule,
        TableSelectedDocumentsComponent
    ],
    templateUrl: './comentar.component.html',
    styleUrl: './comentar.component.scss'
})
export class ComentarComponent implements OnInit {
  taskData: number[];
  fetchingComment = false;

  currentUserID: string
  documentsInformation: Documento[] = []

  commentFormGroup = new FormGroup({
    comment: new FormControl("", {
      validators: [
        Validators.required,
        Validators.maxLength(255)
      ]
    })
  })
  participantes: ServidorPublico[] = []
  participantesFiltered?: Observable<ServidorPublico[]>

  departamentos: UnidadOrganizacional[] = []
  departamentosFiltered?: Observable<UnidadOrganizacional[]>

  snackbarData: ScnackbarData = {}
  minDate = new Date(new Date().setDate(new Date().getDate() + 1))

  constructor(
    private router: Router,
    private documentoService: DocumentoService,
    private comentarService: ComentarService,
    private toast: ToastService,
    private authService: AuthService,
    private dateService: DateService,
    private location: Location
  ) {
    inject(AppTitleService).setTitle("Comentar");

    const navigation = this.router.getCurrentNavigation();
    if (!navigation) {
      router.navigateByUrl("/borrador")
    }
    this.taskData = navigation?.extras.state?.["documentIDs"]

    this.taskData.forEach((id) => {
      this.documentoService.getById(id).subscribe({
        next: (response) => {
          this.documentsInformation = [...this.documentsInformation, response]
        }
      })
    })
    this.currentUserID = this.authService.getTokenData()!.id;
  }

  ngOnInit(): void {
  }

  onCrearComentarioSubmit() {
    this.fetchingComment = true
    let accionTareas: AccionTarea[] = []
    const comment = this.commentFormGroup.controls.comment.value
    this.documentsInformation.forEach(document => {
      const accionTarea: AccionTarea = {
        id: document.idTarea,
        idParticipante: Number.parseInt(this.currentUserID),
        fechaExpira: this.dateService.formatDateToCustomString(new Date()),
        comentario: comment!
      }
      accionTareas.push(accionTarea)
    });

    this.comentarService.create(accionTareas).subscribe({
      next: (_) => {
        this.snackbarData.message = "Comentario agregado"
        this.snackbarData.style = SnackbarStyles.Success
        this.snackbarData.iconName = "check_circle"
        this.fetchingComment = false
        this.toast.show(this.snackbarData)
        this.location.back()
      },
      error: (_) => {
        this.snackbarData.message = "Error al agregar comentario"
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.fetchingComment = false
        this.toast.show(this.snackbarData)
      }
    })
  }


  formatDate(date: string): string {
    return this.dateService.formatCustomStringToDate(date)
  }

  selectAllText(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    input.select();
  }

  onCancel() {
    this.location.back()
  }

}
